import { BUTTONS, PluginSettingsIcon } from 'wix-rich-content-plugin-commons';
import { get } from 'lodash';
import { getModalStyles } from 'wix-rich-content-editor-common';
import { FILE_UPLOAD_TYPE } from '../types.js';
import { Modals } from '../modals.js';
import MediaReplaceIcon from '../icons/MediaReplaceIcon.js';
import './file-upload-settings.js';
import 'react';
import 'classnames';
import 'wix-rich-content-common';
import 'wix-rich-content-ui-components';
import '../style-inject.es-746bb8ed.js';
import '../pdfViewer/pdfConsts.js';
import '../icons/fullViewerIcon.js';
import '../icons/miniViewerIcon.js';

const createInlineButtons = ({
  t,
  isMobile,
  settings = {},
  experiments
}) => {
  var _a;
  const icons = get(settings, "toolbar.icons", {});
  const modalStyles = getModalStyles({ isMobile });
  const settingsButton = ((_a = experiments == null ? void 0 : experiments.enableFilePluginPDFViewer) == null ? void 0 : _a.enabled) ? [
    {
      keyName: "settings",
      type: BUTTONS.FILE_UPLOAD_SETTINGS,
      fullHeight: true,
      icon: icons.settings || PluginSettingsIcon,
      modalName: Modals.FILE_UPLOAD_SETTINGS,
      modalStyles,
      t,
      mobile: true,
      tooltipTextKey: "SettingsButton_Tooltip",
      triggerSettingsBi: true,
      pluginId: FILE_UPLOAD_TYPE
    }
  ] : [];
  const replaceButton = {
    keyName: "replace",
    type: BUTTONS.FILES,
    icon: (icons == null ? void 0 : icons.replace) || MediaReplaceIcon,
    settings,
    tooltipTextKey: t("FileUploadReplaceButton_tooltip")
  };
  return [
    { keyName: "sizeSmall", type: BUTTONS.SIZE_SMALL_CENTER, mobile: false },
    { keyName: "sizeContent", type: BUTTONS.SIZE_CONTENT, mobile: false },
    { keyName: "separator2", type: BUTTONS.SEPARATOR, mobile: false },
    { keyName: "sizeSmallLeft", type: BUTTONS.SIZE_SMALL_LEFT, mobile: false },
    { keyName: "alignCenter", type: BUTTONS.ALIGN_CENTER, mobile: false },
    { keyName: "sizeSmallRight", type: BUTTONS.SIZE_SMALL_RIGHT, mobile: false },
    { keyName: "separator3", type: BUTTONS.SEPARATOR, mobile: false },
    replaceButton,
    ...settingsButton,
    { keyName: "delete", type: BUTTONS.DELETE, mobile: true }
  ];
};

export { createInlineButtons as default };
//# sourceMappingURL=inline-buttons.js.map
